/**
 * ЕДИНСТВЕННОЕ место в SPA, где пользовательский текст захардкожен.
 *
 * Исключение вынужденное и ровно одно: этот текст показывается тогда, когда каталог локали
 * НЕ загрузился, — взять строку из каталога здесь физически невозможно.
 *
 * Текст английский, а не армянский, по двум причинам: держать вторую копию армянских строк
 * вне каталога — прямое нарушение §0 CLAUDE.md, а линтер локалей исключений для этого файла
 * не делает и делать не должен. Экран одноразовый и ведёт к перезагрузке страницы.
 */
declare const __DEPLOY_LOCALE__: string;

export const emergency = {
  /** Вшивается Vite на сборке — единственное применение __DEPLOY_LOCALE__. */
  locale: __DEPLOY_LOCALE__,
  title: 'MathMind',
  message: 'Temporary loading error. Please refresh the page.',
  retry: 'Refresh',
} as const;
